import api from '@/api'

export default {
  getMypageArticle: (data:mypage.mypageArticleReq): Promise<mypage.mypageArticleRes> => {
    return api.post({
        url: '/api/hk/MyPage/myarticle',
        data : data

    });
},
}